<template>
  <div class="customerService">
    <keep-alive :exclude="closedViews">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
  import catchs from '@/mixins/catch.mixin';
  import { mapActions } from 'vuex';

  export default {
    name: 'customerService',
    mixins: [catchs],
    created() {
      this.adminMainOrderAction();
    },
    mounted() {
      window.document.title = '天津渤化客户服务系统';
      // this.addCachedView({name: 'customerService', meta: {noCache: false}});
    },
    methods: {
      ...mapActions({
        adminMainOrderAction: 'dictionary/adminMainOrderAction',
        // addCachedView: 'tags/addCachedView',
      }),
    },
  };
</script>
<style lang="scss">
  .customerService {
    display: flex;
    flex: 1;
    overflow: hidden;
    /*overflow: scroll;*/
  }

  .edit {
    // margin-bottom: 20px;

    .edit_header {
      margin-bottom: 3px;
    }

    .edit_from {
      .top-form {
        display: flex;
        flex-wrap: wrap;

        .el-form-item {
          width: 25%;
        }

        .el-form-item:last-child {
          max-width: 25%
        }
      }

      .bottom-form{
        display: flex;
        flex-wrap: wrap;

        .el-form-item {
          width: 50%;
        }

        .el-form-item:last-child {
          max-width: 50%
        }
      }
      .el-select {
        width: 100%;
      }


      .el-date-editor {
        width: 100%;
      }
    }

    .standing-bar {
      margin-bottom: 10px;
    }
  }
</style>
